import React, { useEffect, useState } from "react";
import { Wheat } from "lucide-react";
import { getApiBaseUrl } from "../config/apiBase";

const FALLBACK_DAILY_VERSE = "This is my commandment, That ye love one another, as I have loved you.";

export default function DailyVerse() {
  const [verse, setVerse] = useState(FALLBACK_DAILY_VERSE);

  useEffect(() => {
    let cancelled = false;

    const loadVerse = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/api/daily-verses/today`, {
          headers: { Accept: "application/json" },
        });

        if (!response.ok) {
          return;
        }

        const payload = await response.json();
        if (!cancelled && typeof payload?.verse === "string" && payload.verse.trim()) {
          setVerse(payload.verse.trim());
        }
      } catch (error) {
        console.warn("Daily verse unavailable", error);
      }
    };

    loadVerse();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!verse) {
    return null;
  }

  return (
    <aside className="home-daily-verse" aria-label="Daily verse">
      <Wheat size={18} aria-hidden="true" />
      <p>{verse}</p>
    </aside>
  );
}
